<template>
  <modal
    ref="modal"
    :id="modalId"
  >
    <div class="edit-product">
      <loader
        class="edit-product__loader"
        v-if="showLoader"
      />
      <a
        class="edit-product__image-link"
        :href="productUrl"
      >
        <img
          class="edit-product__image"
          :src="imageUrl"
          :alt="productName"
          width="80"
          height="80"
          loading="lazy"
        >
      </a>
      <div class="edit-product__info">
        <a
          class="edit-product__name"
          :href="productUrl"
        >
          {{ productName }}
        </a>
      </div>
      <div class="edit-product__form">
        <csrf-input
          ref="csrf"
        />
        <template
          v-for="(variation, index) in variations"
          :key="index"
        >
          <product-variations
            class="edit-product__variation"
            :display_string="variation.display_string"
            ref="variation"
            :variations="variation.options"
            :initial-selected-value="variation.selectedOption"
            :name="variation.attributeName"
            @changeVariation="updateNewItemId"
            :edit-product="true"
          />
        </template>
        <counter
          v-show="false"
          ref="quantity"
          class="edit-product__quantity"
          :min="1"
          :initial-value="1"
          name="quantity"
        />
        <a
          href="#"
          class="edit-product__submit-button | button button--size_40"
          @click.prevent="editProductClickHandler"
        >
          {{ $t('checkout.basket.edit.submit.button') }}
        </a>
      </div>
    </div>
  </modal>
</template>

<script>
  import Modal from '../modal/modal.vue';
  import Loader from '../loader/loader.vue';
  import ProductVariations from '../productVariations/productVariations.vue';
  import Counter from '../counter/counter.vue';
  import CsrfInput from '../csrfInput/csrfInput.vue';
  import productService from '../../services/product/product.js';
  // import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js';

  export default {
    components: {
      Modal,
      ProductVariations,
      Counter,
      CsrfInput,
      Loader
    },
    props: {
      location: {
        type: String,
        default: "cart"
      },
      modalId: String
    },
    data() {
      return {
        showLoader: true,
        type: null,
        productUrl: null,
        imageUrl: null,
        productName: null,
        requestData: null,
        editUrl: null,
        variations: [],
        quantity: null,
        entryId: null,
        itemId: null,
        newItemId: null
      };
    },
    created() {
      this.$store.subscribe(mutation => {
        if (mutation.type === 'editProduct') {
          this.editProductHandler(mutation.payload);
        }
      });
    },
    methods: {
      editProductHandler(data) {
        this.productUrl = data.initialData.productUrl;
        this.productName = data.initialData.productName;
        this.imageUrl = data.initialData.imageUrl;
        this.prepareForm(data.editedProduct);
      },
      prepareForm(data) {
        this.entryId = data.entryId;
        this.itemId = data.itemId;
        this.newItemId = data.newItemId;
        this.variations = data.variations;
        this.quantity = data.quantity;
        this.editUrl = data.editUrl;
        this.$refs.quantity.setValue(this.quantity);
        this.imageUrl = data.imageUrl;
        this.showLoader = false;
      },
      editProductClickHandler() {
        let formData = this.createFormDataObject();

        this.$store.dispatch('handleEditProduct', { url: this.editUrl, data: formData })
      },
      createFormDataObject() {
        let data = {};

        data[this.$refs.csrf.getName()] = this.$refs.csrf.getValue();
        data.newItemId = this.newItemId;
        data.itemId = this.itemId;
        data.entryId = this.entryId;
        if (!data.newItemId) {
          data.newItemId = data.itemId;
        }

        this.$refs.variation.forEach((variation, index) => {
          data[this.variations[index].name] = variation.getValue();
        });

        data.quantity = this.$refs.quantity.getValue();

        return data;
      },
      updateNewItemId() {
        let requestData = this.createFormDataObject();

        productService()
          .getProductEditData(this.location, requestData)
          .then(this.prepareForm.bind(this));

      }
    }
  };

</script>
